let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1uSA3")).then(() => parcelRequire('caOBy'));